import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Games from './pages/Games';
import GameForm from './pages/GameForm';
import Categories from './pages/Categories';
import Wallpapers from './pages/Wallpapers';
import Users from './pages/Users';
import Analytics from './pages/Analytics';
import ChatManagement from './pages/chat/ChatManagement';
import Support from './pages/support/Support';
import Notifications from './pages/Notifications';
import WallpaperCategories from './pages/walpapers/WallpaperCategories';
const PrivateRoute = ({ children }) => {
 
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Toaster position="top-right" />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="games" element={<Games />} />
            <Route path="games/new" element={<GameForm />} />
            <Route path="games/edit/:id" element={<GameForm />} />
            <Route path="categories" element={<Categories />} />
            <Route path="wallpapers" element={<Wallpapers />} />
            <Route path="users" element={<Users />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="chat" element={<ChatManagement />} />
            <Route path="support" element={<Support />} />
            <Route path="wallpapers" element={<Wallpapers />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="/wallpaper-categories" element={<WallpaperCategories />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;